import {
  Component,
  Input,
  Output,
  EventEmitter,
  OnInit,
  forwardRef,
  OnChanges,
  SimpleChanges,
} from "@angular/core";
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from "@angular/forms";
import { FormControl } from "@angular/forms";
import { Observable, of } from "rxjs";
import { map, startWith } from "rxjs/operators";

@Component({
  selector: "app-select-location",
  templateUrl: "./app-select-location.component.html",
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => SelectLocationComponent),
      multi: true,
    },
  ],
})
export class SelectLocationComponent
  implements OnInit, OnChanges, ControlValueAccessor
{
  @Input() label: string = "Chọn";
  @Input() options: any[] = [];
  @Input() displayKey: string = "";
  @Input() placeholder: string = "";
  @Output() selectionChange = new EventEmitter<any>();
  @Input() required: boolean = false;
  control = new FormControl("");
  filteredOptions: Observable<any[]> = of([]);

  private onChange = (_: any) => {};
  public onTouched = () => {};

  ngOnInit(): void {
    this.filteredOptions = of(this.options);

    this.control.valueChanges
      .pipe(
        startWith(""),
        map((value) => this._filter(value))
      )
      .subscribe((filtered) => {
        this.filteredOptions = of(filtered);
      });
  }
  ngOnChanges(changes: SimpleChanges): void {
    if (changes["options"]) {
      // Khi options thay đổi, cập nhật lại danh sách
      const currentVal = this.control.value || "";
      this.filteredOptions = of(this._filter(currentVal));
    }
  }
  private _filter(value: string): any[] {
    const filterValue = value?.toLowerCase() || "";
    return filterValue
      ? this.options.filter((opt) =>
          opt[this.displayKey]?.toLowerCase().includes(filterValue)
        )
      : this.options;
  }

  writeValue(value: any): void {
    if (value) {
      this.control.setValue(value);
    }
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  onSelection(value: string) {
    const selected = this.options.find((opt) => opt[this.displayKey] === value);
    this.selectionChange.emit(selected);
    this.onChange(selected);
  }
}
